import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinValues',
  pure: true
})
export class JoinConditionValuesPipe implements PipeTransform {
  transform(values: string[]): string {
    if (!values) {
      return '';
    }
    return values.join('; ');
  }
}
